import Tooltip from "components/Tooltip/Tooltip";
import React, { useEffect, useState } from 'react'
import { FaCheck } from 'react-icons/fa';
import { MdRemoveCircle } from 'react-icons/md';
import fetchData from 'utils/fetchData';

export default function SubmittedScores() {
    const [result, setResult] = useState();
    useEffect(() => {
        GetData();
    }, []);

    const GetData = async () => {
        try {
            var pResult = await fetchData.Post('/api/hrmpsb/SubmittedScores', {});
            setResult(pResult);
        } catch (e) {
            console.log(e);
        }
    };

    return (
        <div>
            <div className="flex items-center justify-between my-2 px-2">
            <div className="flex items-center gap-3"></div>
            <div className="flex items-center gap-3">
                <button
                    className={`flex self-center`}
                    onClick={() => 123}
                >
                    <Tooltip text="Delete All Scores">
                        <MdRemoveCircle className="text-red-600 w-6 h-6" />
                    </Tooltip>
                </button>
            </div>
            </div>
            <table className="mt-4 border w-full max-h-[65vh] relative">
                <thead>
                    <tr className="bg-primary">
                        <th className="border-r w-[30px] ">
                            <input
                                type="checkbox"
                                name="checkbox"
                            />
                        </th>
                        <th className="text-center text-white p-2 border sticky top-0">Applicant</th>
                        <th className="text-center text-white p-2 border sticky top-0">SM</th>
                        <th className="text-center text-white p-2 border sticky top-0">BI</th>
                        <th className="text-center text-white p-2 border sticky top-0">BEI</th>
                        <th className="text-center text-white p-2 border sticky top-0">PSA</th>
                    </tr>
                </thead>

                <tbody>
                    {result?.map(vInterviewer => {
                        return <>
                            <tr className="bg-primary">
                                <th className="border-r  ">
                                    <input
                                        type="checkbox"
                                        name="checkbox"
                                    />
                                </th>
                                <th colspan="5" className="text-white p-2 border text-center">Interviewer: {vInterviewer.interviewerName}</th>
                            </tr>
                            {vInterviewer.jobPositions.map(vJobPosition => {
                                return <>
                                    <tr className='bg-secondary'>
                                        <th className="border-r  ">
                                            <input
                                                type="checkbox"
                                                name="checkbox"
                                            />
                                        </th>
                                        <th colspan="5" className="p-2 border text-center">Job Position: {vJobPosition.jobPositionName}</th>
                                    </tr>
                                    {vJobPosition.applicants.map(vApplicant => {
                                        return <tr>
                                            <th className="border-r  ">
                                                <input
                                                    type="checkbox"
                                                    name="checkbox"
                                                />
                                            </th>
                                            <td className="p-2 border text-center">
                                                {vApplicant.applicantName}
                                            </td>
                                            <td className="p-2 border text-center">
                                                {vApplicant.categories.SM === true && <FaCheck className='m-auto' />}
                                            </td>
                                            <td className="p-2 border text-center">
                                                {vApplicant.categories.BI === true && <FaCheck className='m-auto' />}
                                            </td>
                                            <td className="p-2 border text-center">
                                                {vApplicant.categories.BEI === true && <FaCheck className='m-auto' />}
                                            </td>
                                            <td className="p-2 border text-center">
                                                {vApplicant.categories.PSA === true && <FaCheck className='m-auto' />}
                                            </td>
                                        </tr>
                                    }) /* vJobPosition.applicants.map */}
                                </>
                            }) /* vInterviewer.jobPositions.map */}
                        </>
                    }) /* result?.map(vInterviewer */}
                </tbody>
            </table>
        </div>
    )
}
